import type { PlayerConfig } from "amazon-ivs-player";
import ivsPackage from "amazon-ivs-player/package.json";

const { version } = ivsPackage;

function shouldUseManagedMediaSource() {
  const managed = (window as typeof window & {
    ManagedMediaSource?: { isTypeSupported: (type: string) => boolean };
  }).ManagedMediaSource;
  // IVS 1.56.1 implements this option but does not publish it in PlayerConfig.
  // Enable only the verified SDK and browser capability; other players keep their default path.
  return version === "1.56.1" && typeof MediaSource === "undefined"
    && managed?.isTypeSupported('video/mp4; codecs="avc1.42E01E"') === true;
}

// The JS SDK, worker and WASM must come from the same installed release.
export function getIvsPlayerConfig(): PlayerConfig {
  const assetRoot = `https://player.live-video.net/${version}`;
  const managed = shouldUseManagedMediaSource();
  // IVS classifies Whale separately from Chromium and disables its low-latency path.
  // Keep the worker compatibility fix limited to the SDK/browser we verified live.
  const whale = version === "1.56.1" && /\bWhale\//.test(navigator.userAgent)
    && /\bChrome\//.test(navigator.userAgent) && typeof MediaSource !== "undefined";
  return {
    wasmWorker: whale ? `/amazon-ivs-whale-worker-loader.js?v=${version}`
      : `${assetRoot}/amazon-ivs-worker.min.js`,
    wasmBinary: `${assetRoot}/amazon-ivs-wasmworker.min.wasm`,
    ...(managed ? { mediaConfig: { preferManagedMediaSource: true } } : {}),
    ...(!managed && window.isSecureContext && "serviceWorker" in navigator
      ? { serviceWorker: { url: `/amazon-ivs-service-worker-loader.js?v=${version}` } }
      : {}),
  };
}
